'use strict';

angular.module('dekky.forms')
.provider('form', function() {
	this.defaults = {};

	this.$get = function($log, formField, formsConfig) {
		function formFactory(name, config) {
			function Form(name) {
				this.name = name;
				this.config = angular.merge({}, formsConfig, config || {});

				Object.defineProperty(this, '$fields', {
					value: {},
					enumerable: false
				});
			}

			/**
			 * Добавляет новое поле в форму
			 *
			 * @param name
			 * @param type
			 * @param config
			 * @returns {formFactory}
			 */
			Form.prototype.addField = function(name, type, config, additionalParams) {
				type = type || 'text';

				this.$fields[name] = formField(name, type, config, additionalParams);
				this.$fields[name].setForm(this);

				return this;
			};

			Form.prototype.field = function(name) {
				return this.$fields[name] || null;
			};

			Form.prototype.setTheme = function(theme) {
				this.config.theme = theme;
			};

			return new Form(name);
		}

		return formFactory;
	}
});